import { useState } from 'react';
import { Callout, DirectionalHint, Link, Text, useTheme } from '@fluentui/react';
import HelpSupport from '../Help/HelpSupport';
import DelegateArea from '../components/DelegateArea';
import { useConfigValuesState } from '../hooks/useConfigValue';

export const UserNotActive = () => {
    const [showHelpCallout, setShowHelpCallout] = useState(false);
    const theme = useTheme();
    const {
        initialData: {
            aggregatedUser: { user },
        },
    } = useConfigValuesState();

    return (
        <>
            <div className="centeredtext">
                <Text
                    styles={{
                        root: {
                            color: theme.semanticColors.bodyText,
                        },
                    }}
                    variant="xxLarge"
                >
                    Sorry, your account "{user.name}" is not active.
                </Text>
                <br />
                <br />
                <Text
                    styles={{
                        root: {
                            color: theme.semanticColors.bodyText,
                        },
                    }}
                    variant="xLarge"
                >
                    Please contact your{' '}
                    <Link id="showhelpbutton" onClick={() => setShowHelpCallout(s => !s)} styles={{ root: { fontStyle: 'inherit', fontWeight: 600 } }}>
                        PMO Support
                    </Link>{' '}
                    if you believe this is not correct.
                </Text>
                {showHelpCallout && (
                    <Callout
                        // style={{ minWidth: 800, minHeight: 300 }}
                        style={{ width: '100%', maxWidth: 800, minHeight: 200 }}
                        gapSpace={0}
                        target={'#showhelpbutton'}
                        directionalHint={DirectionalHint.rightCenter}
                        onDismiss={() => setShowHelpCallout(false)}
                        setInitialFocus
                    >
                        <HelpSupport />
                    </Callout>
                )}
            </div>
            <DelegateArea />
        </>
    );
};
